export default function textHide(shape) {
    shape.attr('text', '');
}
//# sourceMappingURL=text-hide.js.map